export default "__VITE_ASSET__19847103__"